// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"71949de5","31":"a2504d07","141":"24d43f44","341":"294a2983","392":"36adf198","405":"cf131a93","495":"633410e7","533":"8d921f7a","543":"ee03a21e","630":"bd1d2983","787":"ea62b73b","874":"85918aa3","945":"156acf11"}[chunkId] + ".chunk.js";
};